/* Tessera front-end helpers.
   1. tessera-daily landing page: plan sync, sticky add-to-cart, cart drawer bridge.
   2. about-us page: points the "Join the movement" CTA at the account login.
      That button is hardcoded inside templates/page.contact-us.liquid (146KB),
      which the About us page renders via its "contact-us" template suffix.
      Patched here rather than rewriting that whole file. */

/* ---------- 2. About us: Join the movement -> account login ---------- */
(function () {
  function fixJoin() {
    var links = document.querySelectorAll('a.btn, a.nav-cta');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var txt = (a.textContent || '').trim().toLowerCase();
      var href = a.getAttribute('href') || '';
      if (txt === 'join the movement' && (href === '#' || href === '')) {
        a.setAttribute('href', '/account');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixJoin);
  } else {
    fixJoin();
  }
})();

/* ---------- 1. tessera-daily landing page ---------- */
(function () {
  var PLANS = {
    '90':   { qty: 3, btn: '$21/mo', serving: '$0.70 / serving' },
    '30':   { qty: 1, btn: '$24/mo', serving: '$0.80 / serving' },
    'once': { qty: 1, btn: '$30.00', serving: '$1.00 / serving' }
  };

  var tlp, atc, sticky, sel, selWrap, priceEl, servingEl, stickyBtn, opener, buybox;
  var current = '90';

  function variantId() {
    var el = tlp && tlp.querySelector('[data-variant]');
    return el ? el.getAttribute('data-variant') : null;
  }

  function hasOption(plan) {
    if (!sel) { return false; }
    return !!sel.querySelector('option[value="' + plan + '"]');
  }

  function paint(plan) {
    var p = PLANS[plan];
    if (!p) { return; }
    current = plan;

    tlp.querySelectorAll('.plan[data-plan]').forEach(function (card) {
      if (card.getAttribute('data-plan') === plan) {
        card.classList.add('sel');
      } else {
        card.classList.remove('sel');
      }
    });

    if (selWrap) {
      if (hasOption(plan)) {
        selWrap.style.display = '';
        if (sel.value !== plan) { sel.value = plan; }
      } else {
        selWrap.style.display = 'none';
      }
    }

    if (priceEl) { priceEl.textContent = p.btn; }
    if (servingEl) { servingEl.textContent = p.serving; }
  }

  function addToCart(qty, btn) {
    var id = variantId();
    if (!id) { return; }
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      if (opener) { opener.click(); }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    });
  }

  function onScroll() {
    if (!sticky || !buybox) { return; }
    var r = buybox.getBoundingClientRect();
    var past = r.bottom < 140;
    if (past) {
      sticky.classList.add('is-on');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-on');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function init() {
    tlp = document.getElementById('tlp');
    if (!tlp) { return; }

    atc       = document.getElementById('tlpAtc');
    sticky    = document.getElementById('tlpSticky');
    sel       = document.getElementById('tlpStickySelect');
    selWrap   = document.getElementById('tlpStickySelectWrap');
    priceEl   = document.getElementById('tlpStickyPrice');
    servingEl = document.getElementById('tlpStickyServing');
    stickyBtn = document.getElementById('tlpStickyBtn');
    opener    = document.getElementById('tcdOpener');
    buybox    = document.getElementById('offer');

    paint('90');

    tlp.addEventListener('click', function (e) {
      if (e.target.closest('.gifts')) { return; }

      var card = e.target.closest('.plan[data-plan]');
      if (card) { paint(card.getAttribute('data-plan')); return; }

      var once = e.target.closest('[data-plan="once"]');
      if (once) { e.preventDefault(); paint('once'); return; }

      if (atc && e.target.closest('#tlpAtc')) {
        e.preventDefault();
        addToCart(PLANS[current].qty, atc);
      }
    });

    if (sel) {
      sel.addEventListener('change', function () { paint(sel.value); });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(PLANS[current].qty, stickyBtn);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
